module.exports = __webpack_public_path__ + "img/afsaka_yes.f5aa9293.png";